<template>
  <CRow class="main bg-gray-100">
    <CCol class="min-vh-100" :sm="{ size: '12' }" :md="{ size: '10', offset: '1' }" :xl="{ size: '12', offset: '0' }">
      <CContainer>
        <CRow v-if="nameRouter" class="mb-2">
          <HeaderPage :itensBreadcrumb="itensBreadcrumb" :titlePage="nameRouter" :showCancel="showCancel" />
        </CRow>
        <CRow>
          <CCol v-show="message.length" sm="12" class="mb-4">
            <CAlert color="danger" v-for="(item, i) in message" closeButton :key="i">
              {{ item }}
            </CAlert>
          </CCol>
          <CCol>
            <router-view></router-view>
          </CCol>
        </CRow>
      </CContainer>
    </CCol>
  </CRow>
</template>

<script>
import { linksBreadCrumb } from './index'
import { audienceRoutes } from '../index.js'

import HeaderPage from './../components/HeaderPage'
export default {
  name: 'index-audience',
  components: {
    HeaderPage,
  },

  data() {
    return {
      titlePages: '',
      itensBreadcrumb: [],
      modalClose: false,
      message: [],
      nameRouterImportation: 'Import Contacts',
    }
  },

  created() {
    if (this.$route.name == 'choose-methods') {
      this.isStepsImport()
    }
  },

  mounted() {
    this.message = []

    this.isFirstAudience()
    this.hasAudienceInProcess()
  },

  beforeUpdate() {
    const pathRouter = this.$route.path.split('/')[2] || this.$route.path.split('/')[1]
    if (pathRouter != 'import-contacts') {
      this.itensBreadcrumb = []
      return
    }

    this.isStepsImport()
  },

  beforeDestroy() {
    this.message = []
  },

  methods: {
    isStepsImport() {
      // this.itensBreadcrumb = linksBreadCrumb()
      this.itensBreadcrumb = linksBreadCrumb(audienceRoutes, this.$route.matched[1].path, this.$route.params.type)
    },

    isFirstAudience() {
      this.$store
        .dispatch('audience/hasAudience', this.organizationId)
        .then()
        .catch((error) => {
          this.message.push(error.response.data.message || 'an application error was found')
        })
    },

    hasAudienceInProcess() {
      this.$store
        .dispatch('audience/hasAudienceInProcess', this.organizationId)
        .then()
        .catch((error) => {
          this.message.push(error.response.data.message || 'an application error was found')
        })
    },
  },

  computed: {
    nameRouter() {
      if (this.$route.meta.name) {
        return this.$t(this.$route.meta.name)
      }

      return null
    },

    showCancel() {
      return this.nameRouter == this.nameRouterImportation ? true : false
    },

    organizationId() {
      return this.$store.state.auth.organizationId
    },

    hasAudience() {
      return this.$store.state.audience.hasAudience ? this.nameRouterImportation : 'Create Audience'
    },
  },
}
</script>

<style lang="scss" scope>
.main {
  padding-top: 7vh;
}
</style>
